import { useTour } from '../../core/hooks/useTour.js';
import { getMenuSteps } from '../../core/utils/tour.js';
import { useRef, useCallback, useEffect } from 'react';
import { useMutation } from '@tanstack/react-query';
import { setSeen } from '../../core/data/mutation.js';
import { useMenuAxios } from '../../core/context/axios.js';
import { useCoreQuery } from '../../core/hooks/use-core-query.js';

const useMenuTour = (menuOnboardingSeen) => {
  const {
    instance
  } = useMenuAxios();
  const {
    setIsOpen,
    setSteps
  } = useTour();
  const ref = useRef(null);
  const {
    mutateAsync
  } = useMutation({
    mutationFn: (id) => setSeen(instance, id)
  });
  const {
    refetch
  } = useCoreQuery();
  const setOnboarding = useCallback(async () => {
    try {
      await mutateAsync("MENU");
      await refetch();
    } catch (error) {
      console.error(error);
    }
  }, [mutateAsync, refetch]);
  useEffect(() => {
    if (ref.current && !menuOnboardingSeen) {
      setSteps?.(getMenuSteps(ref, setOnboarding));
      setTimeout(() => setIsOpen(true), 1e3);
    }
  }, [ref, setSteps, menuOnboardingSeen, setIsOpen, mutateAsync, setOnboarding]);
  return ref;
};

export { useMenuTour };
